import { 
  POSITION_ATTRIBUTES, 
  POSITION_TEI_TYPE,
  PERFORMANCE_MANAGEMENT_PROGRAM,
  POSITION_HISTORY_PROGRAM,
  POSITION_HISTORY_STAGE,
  POSITION_DATA_ELEMENTS,
} from './constants';

// Helper function to extract attributes from TEI
export const  extractAttributes = (attributesArray) => {
  const result = {};
  if (attributesArray) {
    attributesArray.forEach(attr => {
      const attrId = typeof attr.attribute === 'object' ? attr.attribute.id : attr.attribute;
      result[attrId] = attr.value;
    });
  }
  return result;
};

// Helper function to extract data values from events
export const extractDataValues = (dataValuesArray) => {
  const result = {};
  if (dataValuesArray) {
    dataValuesArray.forEach(dv => {
      result[dv.dataElement] = dv.value;
    });
  }
  return result;
};

export const positionApi = {
  // Get all positions from Position TEIs
  getPositionsQuery: {
    positions: {
      resource: 'trackedEntityInstances',
      params: ({ orgUnit }) => ({
        trackedEntityType: POSITION_TEI_TYPE,
        ou: orgUnit,                  
        ouMode: 'DESCENDANTS',
        fields: 'trackedEntityInstance,orgUnit,attributes[attribute,value]',
        pageSize: 1000
      })
    }
  },

  // Create position as TEI
  createPosition: {
    type: 'create',
    resource: 'trackedEntityInstances',
    data: ({ positionData }) => ({
      trackedEntityType: POSITION_TEI_TYPE,
      orgUnit: positionData.orgUnit,
      attributes: [
        { attribute: POSITION_ATTRIBUTES.POSITION_ID, value: positionData.positionId || '' },
        { attribute: POSITION_ATTRIBUTES.POSITION_TITLE, value: positionData.positionTitle || '' },
        { attribute: POSITION_ATTRIBUTES.DEPARTMENT, value: positionData.department || '' },
        { attribute: POSITION_ATTRIBUTES.JOB_GRADE, value: positionData.jobGrade || '' },
        { attribute: POSITION_ATTRIBUTES.POSITION_STATUS, value: positionData.status || 'Active' },
        { attribute: POSITION_ATTRIBUTES.CURRENT_INCUMBENT, value: positionData.currentIncumbent || '' },
        { attribute: POSITION_ATTRIBUTES.REPORTING_TO, value: positionData.reportingTo || '' } 
      ]
    })
  },

  // Enroll position in PERFORMANCE MANAGEMENT program
  enrollInPerformanceProgram: {
    type: 'create',
    resource: 'enrollments',
    data: ({ teiId, orgUnit }) => ({
      trackedEntityInstance: teiId,
      program: PERFORMANCE_MANAGEMENT_PROGRAM,
      orgUnit: orgUnit,
      enrollmentDate: new Date().toISOString().split('T')[0],
      incidentDate: new Date().toISOString().split('T')[0],
      status: 'ACTIVE'
    })
  },

  // Update position TEI - FIXED: removed trackedEntityType
  updatePosition: {
    type: 'update',
    resource: 'trackedEntityInstances',
    id: ({ teiId }) => teiId,
    data: ({ positionData }) => ({
      orgUnit: positionData.orgUnit,
      attributes: [
        { attribute: POSITION_ATTRIBUTES.POSITION_ID, value: positionData.positionId || '' },
        { attribute: POSITION_ATTRIBUTES.POSITION_TITLE, value: positionData.positionTitle || '' },
        { attribute: POSITION_ATTRIBUTES.DEPARTMENT, value: positionData.department || '' },
        { attribute: POSITION_ATTRIBUTES.JOB_GRADE, value: positionData.jobGrade || '' },
        { attribute: POSITION_ATTRIBUTES.POSITION_STATUS, value: positionData.status || 'Active' },
        { attribute: POSITION_ATTRIBUTES.CURRENT_INCUMBENT, value: positionData.currentIncumbent || '' },
        { attribute: POSITION_ATTRIBUTES.REPORTING_TO, value: positionData.reportingTo || '' } 
      ]
    })
  },

  // Delete position TEI
  deletePosition: {
    type: 'delete',
    resource: 'trackedEntityInstances',
    id: ({ teiId }) => teiId
  },

  // Create staff assignment history event - FIXED: removed attribute from dataValues
  createStaffAssignmentEvent: {
    type: 'create',
    resource: 'events',
    data: ({ historyData }) => ({
      program: POSITION_HISTORY_PROGRAM,
      programStage: POSITION_HISTORY_STAGE,
      orgUnit: historyData.orgUnit,
      eventDate: historyData.eventDate || new Date().toISOString().split('T')[0],
      status: 'COMPLETED',
      trackedEntityInstance: historyData.teiId, // Link to the position TEI
      dataValues: [
        { dataElement: POSITION_DATA_ELEMENTS.ACTION_TYPE, value: historyData.actionType || 'STAFF_ASSIGNMENT' },
        { dataElement: POSITION_DATA_ELEMENTS.POSITION_ID, value: historyData.positionReference || '' },
        { dataElement: POSITION_DATA_ELEMENTS.STAFF_MEMBER, value: historyData.staffId || '' },
        { dataElement: POSITION_DATA_ELEMENTS.START_DATE, value: historyData.startDate || new Date().toISOString().split('T')[0] },
        { dataElement: POSITION_DATA_ELEMENTS.EFFECTIVE_DATE, value: historyData.effectiveDate || new Date().toISOString().split('T')[0] },
        { dataElement: POSITION_DATA_ELEMENTS.NOTES, value: historyData.notes || 'History record' }
      ]
    })
  },

  // Get position history
  getPositionHistory: {
    resource: 'events',
    params: ({ positionReference }) => ({
      program: POSITION_HISTORY_PROGRAM,
      programStage: POSITION_HISTORY_STAGE,
      filter: [`${POSITION_DATA_ELEMENTS.POSITION_ID}:eq:${positionReference}`],
      fields: 'event,eventDate,dataValues[dataElement,value]',
      order: 'eventDate:desc',
      pageSize: 100
    })
  }
};